import {useState} from "react";
import className from "classnames/bind";
import {Button, FontAwesomeIcon} from "~/components";
import SchemaFieldList from "./SchemaFieldList";
import style from "../style/SchemaTool.module.scss";

const cn = className.bind(style);

/**
 * Field lặp lại (type='array', vd mainEntity của FAQPage, itemListElement của
 * BreadcrumbList, openingHoursSpecification). Mỗi phần tử là 1 entity con render
 * qua SchemaFieldList; có nút thêm/xoá.
 *
 * Thu gọn được như NestedFieldGroup — mặc định đóng khi không bắt buộc và chưa có
 * phần tử nào; tự mở khi có dữ liệu.
 *
 * value: mảng object (mỗi object = giá trị 1 phần tử).
 */
function RepeatableField({field, value = [], onChange}) {

	const items = Array.isArray(value) ? value : [];
	const [manual, setManual] = useState(null);
	const collapsed = manual !== null ? manual : !(field.required || field.rich || items.length > 0);

	const addItem = () => onChange([...items, {}]);

	const removeItem = (idx) => onChange(items.filter((_, i) => i !== idx));

	const updateItem = (idx, val) => onChange(items.map((it, i) => (i === idx ? val : it)));

	return (
		<div className={cn('repeat', {collapsed})}>
			<button type="button" className={cn('repeat-head')} onClick={() => setManual(!collapsed)}>
				<FontAwesomeIcon icon={collapsed ? 'fa-light fa-chevron-right' : 'fa-light fa-chevron-down'} />
				{field.label}
				{field.required && <span className={cn('req')}> *</span>}
				{field.rich && <span className={cn('rich-badge')}>rich result</span>}
				<span className={cn('nested-type')}>{field.of}[]</span>
				{items.length > 0 && <span className={cn('repeat-count')}>{items.length}</span>}
			</button>

			{!collapsed && (
				<>
					{items.map((item, idx) => (
						<div className={cn('repeat-item')} key={idx}>
							<div className={cn('repeat-item-head')}>
								<span>#{idx + 1}</span>
								<Button small red onClick={() => removeItem(idx)}
									leftIcon={<FontAwesomeIcon icon="fa-light fa-trash" />} />
							</div>
							<SchemaFieldList fields={field.fields} values={item || {}} onChange={(v) => updateItem(idx, v)} />
						</div>
					))}

					<Button small outline onClick={addItem}
						leftIcon={<FontAwesomeIcon icon="fa-light fa-plus" />}>
						Thêm {field.of}
					</Button>
				</>
			)}
		</div>
	);
}

export default RepeatableField;
